import { util } from '../util';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '@app/shared/services/date.util';

export function autoCompleteDate(input:JQuery<HTMLElement>):string {
  const dateValue:string = input.val();

  if (dateValue.match(/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/)) {
    return dateValue;
  }

  const today:Date = new Date();
  const thisDay:number = today.getDate();
  const thisMonth:number = today.getMonth();
  const thisYear:number = today.getFullYear();

  const dateArray:string[] = dateValue.split('/');
  const dayString:string = dateArray[ 0 ];
  const monthString:string = dateArray[ 1 ];
  const yearString:string = dateArray[ 2 ];

  const newDate:number[] = [
    thisYear,
    thisMonth,
    thisDay
  ];

  if (util.stringContains(dayString, 'd')) {
    dayString.replace('d', '');
    newDate[ 2 ] = parseInt(dayString, 10);
  } else if (monthString === 'mm') {
    newDate[ 2 ] = parseInt(dayString, 10);
  } else if (util.stringContains(monthString, 'm')) {
    monthString.replace('m', '');
    newDate[ 2 ] = parseInt(dayString, 10);
    newDate[ 1 ] = parseInt(monthString, 10) - 1;
  } else if (yearString === 'yyyy') {
    newDate[ 2 ] = parseInt(dayString, 10);
    newDate[ 1 ] = parseInt(monthString, 10) - 1;
  } else if (util.stringContains(yearString, 'yy')) {
    yearString.replace(/y/g, '');
    newDate[ 2 ] = parseInt(dayString, 10);
    newDate[ 1 ] = parseInt(monthString, 10) - 1;
    newDate[ 0 ] = parseInt(yearString, 10);
  } else if (util.stringContains(yearString, 'y')) {
    newDate[ 2 ] = parseInt(dayString, 10);
    newDate[ 1 ] = parseInt(monthString, 10) - 1;
    newDate[ 0 ] = parseInt(parseInt(yearString, 10) + '0', 10);
  }

  return moment.utc(newDate).format(DEFAULT_DATE_FORMAT);
}